
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ls} from "@/CultureService";

@Component
export default class LabelOptional extends Vue {
  @Prop({default: ls.Global_Label_Optional})
  labelText!: string;
}
